/** 1.3.1 portal strings, stream Q4 (workflow steps): keys under workflow. if an assignment a workflow made needs any text for suppliers. Q4's file. */
export const EXTRAS_Q4_STRINGS = {} as const;
